export default __webpack_public_path__ + "static/media/paralax.9bb8bd6f.PNG";